import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Alert, Box, Button, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { CustomContactsField } from './CustomContactsField';
import { Controller } from 'react-hook-form';
import { useFlags } from 'launchdarkly-react-client-sdk';

export type CustomContactSectionFormState = {
  request: {
    customContacts?: {
      to: string[];
      cc: string[];
    };
  };
};

export const CustomContactSection: React.FC<{
  brandPortalKey: string;
}> = ({ brandPortalKey }) => {
  const [customContactsActive, setCustomContactsActive] = useState(false);

  const { brandPortalCustomContacts } = useFlags();

  if (!brandPortalCustomContacts) {
    return null;
  }

  const alertIcon = <MailOutlineIcon />;

  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="h6" gutterBottom>
        Contact
      </Typography>

      {customContactsActive ? (
        <>
          <Alert
            color="info"
            icon={alertIcon}
            action={
              <Button
                variant="outlined"
                color="info"
                onClick={() => setCustomContactsActive(false)}
              >
                Covalo's contact
              </Button>
            }
          >
            <Typography>
              Enter your contact below or revert to Covalo's contact.
              <br />
              <Link
                color="info"
                component={RouterLink}
                to={`/event/${brandPortalKey}/customContacts`}
                target="_blank"
              >
                View contact List
              </Link>
            </Typography>
          </Alert>
          <Controller<CustomContactSectionFormState>
            name="request.customContacts.to"
            rules={{ required: 'Please enter at least one email address.' }}
            render={({ field, fieldState: { error } }) => (
              <CustomContactsField
                label="To"
                testId="ToField"
                brandPortalKey={brandPortalKey}
                onChange={field.onChange}
                error={error?.message}
              />
            )}
          />
          <Controller<CustomContactSectionFormState>
            name="request.customContacts.cc"
            render={({ field }) => (
              <CustomContactsField
                label="Cc"
                testId="CcField"
                brandPortalKey={brandPortalKey}
                onChange={field.onChange}
              />
            )}
          />
        </>
      ) : (
        <Alert
          color="info"
          icon={alertIcon}
          action={
            <Button
              variant="outlined"
              color="info"
              onClick={() => setCustomContactsActive(true)}
            >
              Custom contact
            </Button>
          }
        >
          <Typography>Default recipients are Covalo's key contacts.</Typography>
        </Alert>
      )}
    </Box>
  );
};
